



























































import G_090_ZaikoIdoIraiEntry_ChildActionsBtn from '@/components/G_kaigai/G_090_ZaikoIdoIraiEntry_ChildActionsBtn.vue';
import { Color, Flg, ShoriKb } from '@/constants/constants';
import { isShorikbREFER } from '@/utils/utils';
import Vue from 'vue';

export default Vue.extend<any, any, any, any>({
  name: 'G_090_ZaikoIdoIraiEntry_ChildHeaderInput_Table',
  components: {
    G_090_ZaikoIdoIraiEntry_ChildActionsBtn,
  },
  props: {
    shoriKb: {
      type: Number,
      default: ShoriKb.UPD,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    ShoriKb,
    Flg,
    Color,

    headers: [
      {
        text: '№',
        value: 'numberOrder',
        sortable: false,
        width: 50,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: '品目',
        value: 'himmoku',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        sortable: false,
      },
      {
        text: '単位',
        value: 'tani',
        sortable: false,
        width: 70,
      },
      {
        text: '入数',
        value: 'irisu',
        sortable: false,
        width: 70,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: '数量',
        value: 'idoSuryo',
        sortable: false,
        width: 70,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: '重量',
        value: 'idoJuryo',
        sortable: false,
        width: 100,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        width: 40,
      },
    ],
  }),
  computed: {
    isRef() {
      return isShorikbREFER(this.shoriKb);
    },
    tableHeight() {
      return this.$vuetify.breakpoint.height - 460;
    },
  },
});
